import { EventsApi } from './events';
import { FilesApi } from './files';
import { StatisticsApi } from './statistics';
import{ SqlFiltersApi } from './sql_filters';
import { RequestsApi } from './requests';
import { HealthMonitorApi } from './health_monitor';
import { GatewayApi } from './base';
import { withIOApi } from './io';
import { useContext, useState } from 'react';
import { AuthContext } from '../components/Authentication';


class MissingSources extends withIOApi(GatewayApi) {
    constructor() {
        super('configs');
        this.allowedMethods = new Set('index');
    }

    index() {
        return this.invoke('missing_sources') ?? [];
    }
}


const IOGateway = withIOApi(GatewayApi);


export const api = {
    bucket: () => new IOGateway('bucket'),
    venueLibs: () => new IOGateway('venueLibs'),
    configs: () => new IOGateway('configs'),
    sqlFilters: () => new SqlFiltersApi(),
    statistics: () => new StatisticsApi(),
    files: () => new FilesApi(),
    missingSources: () => new MissingSources(),
    events: () => new EventsApi(),
    requests: () => new RequestsApi(),
    healthMonitor: () => new HealthMonitorApi()
};

type apiKeys = keyof typeof api;
type apiTypes = typeof api[apiKeys]


export function useApi<T extends ReturnType<apiTypes>>(apiType: () => T) {
    const [instance] = useState<T>(apiType());

    const { user } = useContext(AuthContext);
    if (instance.user !== user) {
        instance.setUser(user);
    }

    return instance;
}
